import { Provider } from '@angular/core';
import { DrupalTerm } from '@nx-icilalune/drupal-types';
import {
  GetEntitiesPipe,
  GetRequestPipe,
  JsonApiQuery,
} from '@nx-icilalune/data/access';
import { map, switchMap } from 'rxjs';
import { isEqual } from '@madeinlune/ngx-operators';
import {
  businessUnitQuery,
  domainsQuery,
  technologiesQuery,
  typesQuery,
} from '@nx-icilalune/data/icilalune/queries';
import {
  TERMS_BUSINESS_UNIT,
  TERMS_DOMAIN,
  TERMS_TECHNOLOGY,
  TERMS_TYPE,
} from '@nx-icilalune/data/icilalune/tokens';

function getTerms(
  getRequestPipe: GetRequestPipe,
  getEntitiesPipe: GetEntitiesPipe,
  query: JsonApiQuery
) {
  return getRequestPipe.transform(query.queryId).pipe(
    map((query) => {
      return query?.allResultIds;
    }),
    switchMap((resultIds) => {
      return getEntitiesPipe.transform<DrupalTerm[]>(resultIds);
    }),
    isEqual()
  );
}

export const TERMS_PROVIDERS: Provider[] = [
  {
    provide: TERMS_TYPE,
    deps: [GetRequestPipe, GetEntitiesPipe],
    useFactory: (getRequestPipe, getEntitiesPipe) =>
      getTerms(getRequestPipe, getEntitiesPipe, typesQuery),
  },
  {
    provide: TERMS_DOMAIN,
    deps: [GetRequestPipe, GetEntitiesPipe],
    useFactory: (getRequestPipe, getEntitiesPipe) =>
      getTerms(getRequestPipe, getEntitiesPipe, domainsQuery),
  },
  {
    provide: TERMS_TECHNOLOGY,
    deps: [GetRequestPipe, GetEntitiesPipe],
    useFactory: (getRequestPipe, getEntitiesPipe) =>
      getTerms(getRequestPipe, getEntitiesPipe, technologiesQuery),
  },
  {
    provide: TERMS_BUSINESS_UNIT,
    deps: [GetRequestPipe, GetEntitiesPipe],
    useFactory: (getRequestPipe, getEntitiesPipe) =>
      getTerms(getRequestPipe, getEntitiesPipe, businessUnitQuery),
  },
];
